<template>
  <div>
    <template v-if="!showTotpStep">
      <vs-input
        v-validate="'required|min:3'"
        data-vv-validate-on="blur"
        name="username"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Username"
        v-model="username"
        class="w-full"
      />
      <span class="text-danger text-sm">{{ errors.first('username') }}</span>

      <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:3|max:20'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-6"
      />
      <span class="text-danger text-sm">{{ errors.first('password') }}</span>

      <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
      </div>
      <div class="flex flex-wrap justify-between mb-3">
        <vs-button :disabled="!validateForm" @click="loginCustom">Login</vs-button>
      </div>
    </template>

    <template v-else>
      <p class="mb-4 text-sm">
        Enter the 6-digit code from your Google Authenticator app for <strong>{{ (pendingUserInfo && pendingUserInfo.email) || '' }}</strong>.
      </p>
      <vs-input
        v-model="totpCode"
        label-placeholder="Authentication code"
        placeholder="000000"
        class="w-full"
        maxlength="6"
        type="tel"
        inputmode="numeric"
        pattern="[0-9]*"
        @input="onTotpInput"
        @keyup.enter="verifyTotp"
      />
      <div class="flex flex-wrap justify-between mt-4 mb-3">
        <vs-button type="border" @click="backFromTotp">Back</vs-button>
        <vs-button :disabled="totpCode.length != 6" @click="verifyTotp">Verify</vs-button>
      </div>
    </template>
  </div>
</template>

<script>
import axios from '@/axios.js'
import { getDefaultHomePath } from '@/utils/accessRoutes'

export default {
  data() {
    return {
      username: '',
      password: '',
      checkbox_remember_me: true,
      showTotpStep: false,
      pendingUserInfo: null,
      totpCode: ''
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.username !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      return true
    },

    backFromTotp() {
      this.clearLoginSession()
      this.showTotpStep = false
      this.pendingUserInfo = null
      this.totpCode = ''
    },

    onTotpInput() {
      this.totpCode = String(this.totpCode || '').replace(/\D/g, '').slice(0, 6)
    },

    clearLoginSession() {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('unitSelection')
      localStorage.removeItem('allUnits')
      localStorage.removeItem('cctvSelection')
      localStorage.removeItem('cctvUnits')
      localStorage.removeItem('mapPOIData')
      localStorage.removeItem('geoPOIData')
      localStorage.removeItem('unreadNotif')
      localStorage.removeItem('unreadNotifications')
      localStorage.removeItem('unreadNotif2')
      localStorage.removeItem('unreadNotifications2')
      localStorage.removeItem('logo_big_url')
      localStorage.removeItem('logo_small_url')
      localStorage.removeItem('beaconData')
      localStorage.removeItem('beaconIdsData')
      delete axios.defaults.headers.common['Authorization']
      this.$acl.change('isLoggedOut')
    },

    verifyTotp() {
      if (!this.pendingUserInfo || this.totpCode.length !== 6) return
      const self = this
      this.$vs.loading()
      axios
        .post('/clients/verify-totp', {
          username: this.pendingUserInfo.username,
          uid: this.pendingUserInfo.uid,
          code: this.totpCode,
          platform: 'Web'
        })
        .then((response) => {
          self.$vs.loading.close()
          self.showTotpStep = false
          self.pendingUserInfo = null
          self.totpCode = ''
          if (response.data && response.data.accessToken && response.data.userInfo) {
            self.$store.dispatch('auth/completeLoginFromTotp', response.data)
            self.$acl.change(response.data.userInfo.userRole)
            self.$router.push(getDefaultHomePath(response.data.userInfo)).catch((err) => console.log(err))
          } else {
            self.$vs.notify({
              title: 'Verification failed',
              text: 'Invalid response from server.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((err) => {
          self.$vs.loading.close()
          self.clearLoginSession()
          self.showTotpStep = false
          self.pendingUserInfo = null
          self.totpCode = ''
          const msg =
            (err.response && err.response.data && err.response.data.error) || err.message || 'Invalid authentication code.'
          self.$vs.notify({
            title: 'Verification failed',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    loginCustom() {
      if (!this.checkLogin()) return

      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          username: this.username,
          password: this.password
        }
      }

      this.$store
        .dispatch('auth/loginCustom', payload)
        .then((response) => {
          const ui = response.data.userInfo
          if (response.data.requireTotp && ui) {
            this.$vs.loading.close()
            this.pendingUserInfo = ui
            this.showTotpStep = true
            this.totpCode = ''
            return
          }
          this.$vs.loading.close()
          this.$acl.change(ui.userRole)
          this.$router.push(getDefaultHomePath(ui)).catch((err) => console.log(err))
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>
